export interface ReceivingDropdownOption {
  value: number | null;
  label: string;
}

interface ReceivingHeaderValues {
  invoice_number?: string;
  supplier?: ReceivingDropdownOption | null;
  received_by?: ReceivingDropdownOption | null;
  pallet_condition?: ReceivingDropdownOption | null;
  truck_condition?: ReceivingDropdownOption | null;
  truck_temperature?: string | number | null;
  is_barcode?: ReceivingDropdownOption | null;
}

export function normalizeOptionalPurchaseOrder(
  purchaseOrder?: ReceivingDropdownOption | null,
): ReceivingDropdownOption | null {
  return purchaseOrder?.value && purchaseOrder.value > 0 ? purchaseOrder : null;
}

export function receivingConditionId(value: unknown): 1 | 2 | null {
  const raw =
    value != null && typeof value === "object" && "value" in value
      ? (value as { value: unknown }).value
      : value;
  const id = typeof raw === "number" ? raw : Number(raw);
  return id === 1 || id === 2 ? id : null;
}

export function hasReceivingTemperature(value: unknown): boolean {
  if (typeof value === "number") return Number.isFinite(value);
  if (typeof value === "string") return value.trim() !== "";
  return false;
}

export function isReceivingHeaderReadyForBarcode(
  values: ReceivingHeaderValues,
): boolean {
  return (
    values.is_barcode?.value === 2 &&
    Boolean(values.invoice_number?.trim()) &&
    (values.supplier?.value ?? 0) > 0 &&
    (values.received_by?.value ?? 0) > 0 &&
    (values.pallet_condition?.value ?? 0) > 0 &&
    (values.truck_condition?.value ?? 0) > 0 &&
    values.truck_temperature !== "" &&
    values.truck_temperature !== null &&
    values.truck_temperature !== undefined
  );
}
